import React from 'react'
import { IonToast } from '@ionic/react'
import { useSelector, useDispatch } from 'react-redux'
import { getToastSelector } from './selectors'
import { hideToast } from './store/toast.actions'
import { getToastProps } from './toastIcon.util'

const DEFAULT_TOAST_DURATION = 2000

const Toast: React.FC = () => {
  const dispatch = useDispatch()
  const toastState = useSelector(getToastSelector)

  const handleDismiss = () => {
    dispatch(hideToast())
    if (toastState.onDidDismiss) {
      toastState.onDidDismiss()
    }
  }

  const handleWillPresent = () => {
    if (toastState.onWillPresent) {
      toastState.onWillPresent()
    }
  }

  return (
    <IonToast
      data-testid={toastState.dataTestId}
      isOpen={toastState.showToast}
      onDidDismiss={handleDismiss}
      onWillPresent={handleWillPresent}
      message={toastState.message}
      duration={toastState.duration ?? DEFAULT_TOAST_DURATION}
      position={toastState.position}
      {...getToastProps(toastState.color)}
    />
  )
}

export default Toast
